import type { SalaryFormat } from '@app/api/ClientServices';

export const SALARY_PERCENT: SalaryFormat = 'Percentage';

export const SALARY_RATE: SalaryFormat = 'FixedRate';

export const SALARY_TYPE_SELECT_OPTIONS = [
  {
    value: SALARY_PERCENT,
    label: 'Процент',
  },
  {
    value: SALARY_RATE,
    label: 'Ставка',
  },
];
